function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { ReactNode, useRef } from 'react';
import cn from 'classnames';
import { useForkRef } from '../../hooks/useForkRef';
import ControlOriginal from './Textarea/Textarea-Control';
import { RenderOverride, useRenderOverride } from '../../lib/render-override';
import { Button } from '../Button';
import { ButtonSizes, ButtonThemes } from '../Button';
import { Icon } from '../Icon';
require("./InputText.css");
var styles = {
  "Root": "InputText-module-Root_2jR",
  "Addon": "InputText-module-Addon_dEw",
  "Input": "InputText-module-Input_q36",
  "lSize": "InputText-module-lSize_1mO",
  "mSize": "InputText-module-mSize_2_k"
};
export const InputTextSizes = {
  m: 'm',
  l: 'l'
};
export const InputText = ({
  addonAfter,
  addonBefore,
  className,
  controlRef,
  disabled,
  hasClear = false,
  hasError = false,
  id,
  innerRef,
  multiline = false,
  placeholder,
  renderControl,
  rowsMax = 20,
  rowsMin = 2,
  style,
  type,
  componentSize = InputTextSizes.l,
  ...props
}) => {
  const _controlRef = useRef();
  const ownRef = useForkRef(_controlRef, controlRef);
  const Textarea = useRenderOverride(ControlOriginal, renderControl);

  /**
   * @see {@link https://hustle.bizongo.in/simulate-react-on-change-on-controlled-components-baa336920e04}
   */
  const handleClear = () => {
    const type = multiline ? window.HTMLTextAreaElement.prototype : window.HTMLInputElement.prototype;
    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(type, 'value')?.set;
    if (!_controlRef.current || !nativeInputValueSetter) {
      return;
    }
    nativeInputValueSetter.call(_controlRef.current, '');
    const inputEvent = new Event('input', {
      bubbles: true
    });
    _controlRef.current.dispatchEvent(inputEvent);
    _controlRef.current.focus();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.Root, className),
    style: style,
    ref: innerRef
  }, addonBefore && /*#__PURE__*/React.createElement("div", {
    className: styles.Addon
  }, addonBefore), !multiline ? /*#__PURE__*/React.createElement("input", _extends({}, props, {
    ref: ownRef,
    id: id,
    className: cn(styles.Input, styles[componentSize + 'Size']),
    placeholder: placeholder,
    disabled: disabled,
    "aria-invalid": hasError,
    type: type
  })) : /*#__PURE__*/React.createElement(Textarea, _extends({}, props, {
    controlRef: ownRef,
    className: styles.Input,
    placeholder: placeholder,
    rowsMin: rowsMin,
    rowsMax: rowsMax,
    "aria-invalid": hasError,
    disabled: disabled,
    id: id
  })), (addonAfter || hasClear) && /*#__PURE__*/React.createElement("div", {
    className: cn(styles.Addon, styles.AddonAfter)
  }, hasClear && /*#__PURE__*/React.createElement(Button, {
    name: "clearInput",
    size: ButtonSizes.s,
    theme: ButtonThemes.transparent,
    onClick: handleClear,
    "aria-label": "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u043F\u043E\u043B\u0435"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close"
  })), addonAfter && addonAfter));
};
if (process.env.NODE_ENV !== 'production') {
  InputText.displayName = 'InputText';
}